import { inject, Injectable } from '@angular/core';
import { UserIndexedDbDictionaryRepository } from '../repositories/user-indexed-db-dictionary.repository';
import { IndexedDbDataAccess } from '@softline/core';
import { FavoriteList } from '@softapps/core';
import { SOFTLINE_NAME_FAVORITES_OBJECT_STORE } from '../user.indexed-db';

@Injectable({providedIn: 'root'})
export class FavoriteRepository<T> extends UserIndexedDbDictionaryRepository<FavoriteList<T>> {

  constructor() {
    super(inject(IndexedDbDataAccess), SOFTLINE_NAME_FAVORITES_OBJECT_STORE);
  }

  protected override getKey(item: FavoriteList<T>): string {
    return item.key;
  }
}
